import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request table view.
 * @extends JetView
 */
export default class tableWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        // Custom data filter for summing column values
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    var size = $$('datatable').getPager().config.size; // Get page size
                    var page = $$('datatable').getPage(); // Get current page
                    var first = size * page; // Calculate first item index
                    var last = first + size - 1; // Calculate last item index
                    var count = 0; // Counter for items

                    // Iterate through master data to calculate sum
                    master.data.each(function (obj) {
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Sum the values
                        }
                        count++;
                    });
                    resultFormat = webix.i18n.priceFormat(result); // Format the result
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // Unique ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Define columns for the DataTable
                                {
                                    id: 'detailTittle', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Detalles', // Tooltip text
                                    template: function (obj) {
                                        // Template for rendering cell content
                                        return "<span class='webix_icon wxi-close details'></span>";
                                    },
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'ActionTittle', // Column ID for actions
                                    header: '', // Column header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip text
                                    hidden: !devConfig.getPermAction('withdrawalRequests', 'Edit'), // Conditional visibility based on permissions
                                    css: 'prm-withdrawalRequests', // CSS class for styling
                                    template: function (obj) {
                                        // Template for rendering action buttons
                                        if (
                                            obj.State == 'A' &&
                                            obj.AccountBank !== '' &&
                                            obj.AccountBank !== undefined &&
                                            obj.AccountBank !== null
                                        ) {
                                            return "<span placeholder='Aprobar' class='webix_icon wxi-close approve'></span><span class='webix_icon wxi-close torefuse'></span>";
                                        } else {
                                            if (
                                                obj.State == 'P' &&
                                                obj.AccountBank !== '' &&
                                                obj.AccountBank !== undefined &&
                                                obj.AccountBank !== null
                                            ) {
                                                return "<span placeholder='Pagar' class='webix_icon wxi-close pay'></span>";
                                            } else {
                                                return '';
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'CreatedLocal', // Column ID for creation date
                                    header: _('Fecha'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Column header with localization
                                    options: [
                                        // Options for state dropdown
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Pagada') },
                                        { id: 'E', value: _('Eliminado') },
                                        { id: 'P', value: _('Pendiente') },
                                        { id: 'R', value: _('Rechazado') },
                                    ],
                                },
                                {
                                    id: 'PaymentDate', // Column ID for payment date
                                    header: _('Fecha Pagado'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header with localization
                                    format: webix.i18n.priceFormat, // Formatting function for price
                                    exportType: 'number', // Export type
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                    footer: { content: 'mySummColumn' }, // Footer content using custom summation
                                },
                                {
                                    id: 'Id', // Column ID for ID
                                    header: 'Id', // Column header
                                    width: 70, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'ClientId', // Column ID for client ID
                                    header: _('ID Cliente'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'WayPay', // Column ID for payment method
                                    header: _('Forma de pago'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'PaymentMethod', // Column ID for payment method
                                    header: _('Método de pago'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeAccount', // Column ID for account type
                                    header: _('Tipo de cuenta'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'AccountBank', // Column ID for bank account
                                    header: _('Cuenta Bancaria'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CodeInterbank', // Column ID for interbank code
                                    header: _('Código Interbancario'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Department', // Column ID for department
                                    header: _('Departamento'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'City', // Column ID for city
                                    header: _('Ciudad'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BetShop', // Column ID for betting shop
                                    header: _('Punto de Venta'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID for IP address
                                    header: 'IP', // Column header
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click actions
                                details: function (euv, id) {
                                    // Handler for details button
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    if (screen.width < 500 || screen.height < 500) {
                                        // Check screen size
                                        $$('filterDetails').show(); // Show filter details
                                    } else {
                                        $$('dColl').expand(); // Expand details
                                    }
                                },
                                pay: function (euv, id) {
                                    // Handler for pay button
                                    var vvthis = this; // Reference to the current context
                                    webix
                                        .modalbox({
                                            // Show modal box for payment options
                                            title: _('Pregunta'),
                                            buttons: [_('Pagar por Sistema'), _('Pagado fisicamente'), _('Cancelar')],
                                            text: _('Elija la forma de pago'),
                                            width: 500,
                                        })
                                        .then(function (result) {
                                            // Handle modal result
                                            switch (result) {
                                                case '0': // Pay by system
                                                    webix.confirm({
                                                        // Confirmation dialog
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'),
                                                        ok: _('Pagar Nota'),
                                                        cancel: _('Salir'),
                                                        callback: function (action) {
                                                            // Callback for confirmation
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the item
                                                                webix
                                                                    .ajax() // AJAX request to pay withdrawal
                                                                    .headers({
                                                                        'Content-type': 'application/json',
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Client/PayWithdrawalRequestsAPI',
                                                                        '{ "Id":' + item.Id + '}',
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state
                                                                                webix.message(
                                                                                    'Envio de solicitud de pago. ',
                                                                                ); // Show success message
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '1': // Pay physically
                                                    webix.confirm({
                                                        // Confirmation dialog
                                                        type: 'confirm-warning',
                                                        text:
                                                            _('Advertencia!') +
                                                            '<br/>' +
                                                            _('Desea Pagar Nota de Retiro?'),
                                                        ok: _('Pagar Nota'),
                                                        cancel: _('Salir'),
                                                        callback: function (action) {
                                                            // Callback for confirmation
                                                            if (action === true) {
                                                                var item = vvthis.getItem(id); // Get the item
                                                                webix
                                                                    .ajax() // AJAX request to pay withdrawal
                                                                    .headers({
                                                                        'Content-type': 'application/json',
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'Client/PayWithdrawalRequests',
                                                                        '{ "Id":' + item.Id + '}',
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                item.State = 'I'; // Update item state
                                                                                webix.message('Nota de Retiro Pagada'); // Show success message
                                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                                vthis.$$('table').load(url); // Reload the table data
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    });
                                                    break;
                                                case '2': // Cancel action
                                                    break;
                                            }
                                        });
                                },
                                approve: function (euv, id) {
                                    // Handler for approve button
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Nota de Retiro?'),
                                        ok: _('Aprobar Nota'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax() // AJAX request to approve withdrawal
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/AllowWithdrawalRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'P'; // Update item state
                                                                webix.message('Nota de Retiro Aprobado'); // Show success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                torefuse: function (euv, id) {
                                    // Handler for refuse button
                                    var vvthis = this; // Reference to the current context
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar Nota de Retiro?'),
                                        ok: _('Rechazar Nota'),
                                        cancel: _('Salir'),
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item
                                                webix
                                                    .ajax() // AJAX request to cancel withdrawal
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Client/CancelClientRequests',
                                                        '{ "Id":' + item.Id + '}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message('Error! '); // Show error message
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                item.State = 'E'; // Update item state
                                                                webix.message('Nota de Retiro Rechazada'); // Show success message
                                                                vthis.$$('table').clearAll(); // Clear the table
                                                                vthis.$$('table').load(url); // Reload the table data
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            on: {
                                // Event handlers for DataTable
                                onBeforeLoad: function () {
                                    // Before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // After loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // When the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            editable: true, // Enable editing
                            footer: true, // Show footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'es/Client/GetClientWithdrawalRequests?PlayerId=' + cur_user + '&'; // API URL for fetching withdrawal requests
        var filter = ''; // Filter string

        // Event listener for bonus report filter
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date filter
                                var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter string
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter string
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format date
                                    string1 = string1 + '&' + dateFrom; // Add to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format date
                                        string1 = string1 + '&' + dateTo; // Add to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Add current user to filter string
            grid.clearAll(); // Clear the grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for editing start
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id); // Get the item being edited
            console.log(item);
            if (id.column == 'Action') {
                // Check if editing the Action column
                var options = this.getColumnConfig('Action').collection; // Get action options
                if (item.State == 'A') {
                    options.remove('P'); // Remove 'Pay' option if state is 'A'
                } else if (item.State == 'P') {
                    options.remove('A'); // Remove 'Approve' option if state is 'P'
                } else {
                    return false; // Prevent editing for other states
                }
                console.log(id);
            }
        });

        // Event listener for editing stop
        grid.attachEvent('onAfterEditStop', function (state, editor, ignoreUpdate) {
            console.log(state);
            var item = this.getItem(editor.row); // Get the edited item
            console.log(item);
            if (state.value != state.old) {
                // Check if value has changed
                if (state.value == 'A') {
                    // If approved
                    webix
                        .ajax() // AJAX request to approve withdrawal
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/AllowWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'P'; // Update item state
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
                if (state.value == 'P') {
                    // If paid
                    webix
                        .ajax() // AJAX request to pay withdrawal
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/PayWithdrawalRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'I'; // Update item state
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
                if (state.value == 'E') {
                    // If rejected
                    webix
                        .ajax() // AJAX request to cancel withdrawal
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Client/CancelClientRequests', '{ "Id":' + item.Id + '}', {
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Show error message
                            },
                            success: function (text, data, XmlHttpRequest) {
                                item.State = 'E'; // Update item state
                                webix.message('Cell value was changed'); // Show success message
                            },
                        });
                }
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
